import { getClientEnvironmentDetails } from '@sm/utils';
import { MetricsTracker, USER_EVENTS } from '..';
import { EnvironmentDetails } from '../types/types';

type PageMetricsProviderPropType = {
  pageId: string;
  location?: {
    pathname: string;
  };
  attributes?: Record<string, any>;
  GDPR: {
    hasGDPRConsent: boolean;
  };
  user: {
    id: string;
    package: string;
    email: string;
  };
  countryCode?: string;
  children?: any;
};

const PageMetricsProvider: React.FC<PageMetricsProviderPropType> = ({
  pageId,
  location,
  attributes,
  GDPR,
  user,
  countryCode,
  children
}) => {
  const envDetails = getClientEnvironmentDetails<EnvironmentDetails>();
  const { hasGDPRConsent = false } = GDPR;
  const { id: userId = '1', package: packageId = '1', email = '' } = user;

  if (envDetails.isBrowser) {
    const pagePath = location ? location.pathname : window.location.pathname;

    MetricsTracker.track({
      name: USER_EVENTS.PAGE_VIEW,
      data: {
        pageId,
        attributes,
        pathname: pagePath,
        actionType: USER_EVENTS.PAGE_VIEW,
        actionFlow: pageId,
        data: {
          hasGDPRConsent,
          userId,
          packageId,
          email,
          countryCode
        }
      }
    });
  }
  return children;
};

export default PageMetricsProvider;
